import { useParams } from 'react-router-dom'
import { GetStarted } from '../components/business/GetStarted'

function RegisterBusinessSetupScreen() {
  const { businessId } = useParams<{ businessId: string }>()
  return <GetStarted businessId={businessId!} />
}

export default RegisterBusinessSetupScreen
